<script>

    import Vue from 'vue';
    import DefaultServerTable from '../../Libraries/ServerTable/DefaultServerTable';

    export default {

        extends:DefaultServerTable,

        methods: {
            addProjectStatusFilters() {
                let statuses = JSON.parse(this.projectStatuses);
                // Loop them
                statuses.forEach((status) => {
                    Vue.set(this.$refs.serverTable.filters, "status-" + status.id, {
                        name:"Status: " + status.name,
                        id:"status-" + status.id,
                        enabled:false,
                        onChange:() => {
                            this.$refs.serverTable.resetData();
                        },
                    });
                });
            },
            addTeamFilters() {
                let teams = JSON.parse(this.teams);
                // Loop them
                teams.forEach((team) => {
                    Vue.set(this.$refs.serverTable.filters, "team-" + team.id, {
                        name:"Team: " + team.name,
                        id:"team-" + team.id,
                        enabled:false,
                        onChange:() => {
                            this.$refs.serverTable.resetData();
                        },
                    });
                });
            },
        },

        mounted() {
            this.addProjectStatusFilters();
            this.addTeamFilters();
        },

        props: {
            projectStatuses: { required:true },
            teams: { required:true },
        },

    }

</script>
